"use client"

import { PasswordInput as DsPasswordInput, type PasswordInputProps } from "@instacover/ui-web"
import { useTranslations } from "next-intl"

/** DS PasswordInput with the toggle labels from the portal's translations. */
export function PasswordInput(props: Omit<PasswordInputProps, "toggleLabels">) {
  const t = useTranslations("common")

  return <DsPasswordInput {...props} toggleLabels={{ show: t("showPassword"), hide: t("hidePassword") }} />
}
